import {
    IExtractedCSV,
    IExtractedRow
} from "./CSVExtractor";

import Immutable from "immutable";

export type CallDirection = "inbound" | "outbound" | "";

export interface IMetaData {
    id: string | null;
    timestamp: string | null;
    timezone: string | null;
    email: string | null;
    phone: string | null;
    name: string | null;
    agentName: string | null;
    callDirection: CallDirection | null;
}

export interface IUploadRecord {
    fileName: string;
    contents: ArrayBuffer;
    metaData: IMetaData;
    ignoreMetadata: boolean;
}

interface IMatchedRow extends IExtractedRow {
    matchedFile?: IReadFileResult;
}

export interface IMatchedCSV extends IExtractedCSV {
    rows?: Immutable.List<IMatchedRow>;
}

export type IMatchResult = {
    matchedCSV: IMatchedCSV;
    unmatchedAudioFiles: Immutable.Set<string>;
};

export type IDataMatchResults = {
    matchedMetaDataFiles: Immutable.List<IMatchedCSV>;
    unmatchedAudioFiles: Immutable.List<IReadFileResult>;
    fileSystemErrors: Immutable.List<string>;
};

export interface IReadFileResult {
    status: string;
    fileName: string;
    contents?: String | ArrayBuffer | null;
    error?: any;
}

export function readBinaryFileAsync(file: File): Promise<ArrayBuffer | null> {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = () => {
            resolve(
                reader.result === null ? null : (reader.result as ArrayBuffer),
            );
        };

        reader.onerror = reject;

        reader.readAsArrayBuffer(file);
    });
}

function readTextFileAsync(file: File): Promise<String | null> {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = () => {
            resolve(reader.result === null ? null : (reader.result as String));
        };

        reader.onerror = reject;

        reader.readAsText(file);
    });
}

function _readFilesAsync(
    files: File[],
    readerFunction: (file: File) => Promise<ArrayBuffer | String | null>,
): Promise<IReadFileResult>[] {
    const promises = files.map(async (file) => {
        try {
            const contents = await readerFunction(file);
            return {
                status: "ok",
                fileName: file.name,
                contents,
            };
        } catch (err) {
            return {
                status: "error",
                fileName: file.name,
                error: err,
            };
        }
    });
    return promises;
}

export function readTextFilesAsync(files: File[]): Promise<IReadFileResult>[] {
    return _readFilesAsync(files, readTextFileAsync);
}
